import React, { Component } from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import classnames from 'classnames';
import SubLabelList from 'ps-components/SubLabelList/SubLabelList';
import './Job.scss';
import { orgJob } from '../GlobalJobMatching/propTypes';

class Job extends Component {
  static propTypes = {
    className: string,
    job: shape({
      orgJobCode: string,
      orgJobCodeKey: string,
      currency: string,
      orgJobId: string,
      orgJobTitle: string
    }),
    selectedJob: string,
    onSelectJob: func,
    replacementTokens: arrayOf(
      shape({
        key: string
      })
    ),
    useJobCodeKey: bool,
    isDisabled: bool,
    isCurrentJob: bool
  };

  onSelectJob = () => {
    const { job, onSelectJob, isDisabled } = this.props;
    if (!isDisabled) onSelectJob(job);
  };

  render() {
    const { className, job, replacementTokens, useJobCodeKey, selectedJob, isDisabled, isCurrentJob } = this.props;
    const orgJobCodeKey = replacementTokens.find(value => value.token === 'job_code_key_text');
    const orgJobCodeKeyLabel = orgJobCodeKey?.value || 'Job Code Key';
    let orgJobCodeKeyText = job.orgJobCodeKey;
    if (orgJobCodeKeyText === ' ') orgJobCodeKeyText = 'Not Set';
    let subLabelList = [{ label: 'Job Code', text: job.orgJobCode }];
    if (useJobCodeKey) subLabelList.push({ label: orgJobCodeKeyLabel, text: orgJobCodeKeyText });
    return (
      <div
        className={classnames(className, 'job', {
          job__selected: selectedJob === job.orgJobId,
          job__disabled: isDisabled
        })}
        key={job.orgJobId}
        onClick={this.onSelectJob}
      >
        <div className="job__cell">
          <div className="job__main-line">
            {isCurrentJob && <div className="pxl-text-xsmall job__current-job">(Current Job)</div>}
            <div className="pxl-text-small job__name" title={job.orgJobTitle}>
              {job.orgJobTitle}
            </div>
          </div>
          <div className="job__data">
            <SubLabelList subLabels={subLabelList} />
          </div>
        </div>
      </div>
    );
  }
}

export default Job;
